type ResetPasswordStateCardProps = {
  title: string
  description: string
  actionLabel: string
  actionHref: string
  secondaryLabel: string
  secondaryHref: string
}

export const ResetPasswordStateCard = ({
  title,
  description,
  actionLabel,
  actionHref,
  secondaryLabel,
  secondaryHref,
}: ResetPasswordStateCardProps) => (
  <div className="space-y-4">
    <div className="space-y-2">
      <h2 className="text-xl font-semibold tracking-tight text-(--color-text-primary)">{title}</h2>
      <p className="text-sm leading-relaxed text-(--color-text-secondary)">{description}</p>
    </div>

    <a
      href={actionHref}
      className="ca-btn-primary inline-flex h-11 w-full items-center justify-center px-4 text-sm font-semibold shadow-[0_10px_24px_-18px_color-mix(in_srgb,var(--color-action-primary)_85%,transparent)] transition-colors duration-200"
    >
      {actionLabel}
    </a>

    <a
      href={secondaryHref}
      className="inline-flex w-full items-center justify-center text-sm font-semibold text-(--color-focus-ring) underline decoration-[color-mix(in_srgb,var(--color-focus-ring)_35%,transparent)] underline-offset-4 transition-colors duration-150 hover:text-(--color-text-primary)"
    >
      {secondaryLabel}
    </a>
  </div>
)
